var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5099_13198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9117C24.8366 31.9117 32 29.7786 32 27.1473C32 24.5159 24.8366 22.3828 16 22.3828C7.16344 22.3828 0 24.5159 0 27.1473C0 29.7786 7.16344 31.9117 16 31.9117Z",
    fill: "#3B88C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.056 25.3665C30.056 26.803 27.8338 27.6661 17.1831 27.6661C7.472 27.6661 5.08356 26.803 5.08356 25.3665C5.08356 23.9301 10.1351 22.7656 17.1831 22.7656C24.2311 22.7656 30.056 23.9301 30.056 25.3665Z",
    fill: "#88C9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 25.1105C6.22222 24.2216 7.11111 20.666 16 20.666C26.6667 20.666 29.3333 24.2216 29.3333 25.1105C29.3333 25.9993 29.3333 26.8882 16.8889 26.8882C6.22222 26.8882 6.22222 25.9993 6.22222 25.1105Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3289 24.5933C18.2971 24.7397 18.2367 24.8785 18.1513 25.0017C18.0658 25.1249 17.957 25.23 17.8309 25.3111C17.7048 25.3922 17.564 25.4477 17.4165 25.4744C17.2689 25.501 17.1176 25.4984 16.9711 25.4666C16.8246 25.4348 16.6858 25.3744 16.5626 25.289C16.4395 25.2035 16.3343 25.0947 16.2532 24.9686C16.0895 24.7139 16.0335 24.4047 16.0978 24.1088L20.616 1.01103C20.6434 0.860379 20.7009 0.71679 20.785 0.588814C20.8691 0.460838 20.9781 0.351091 21.1055 0.266109C21.2328 0.181127 21.376 0.122648 21.5265 0.0941531C21.6769 0.0656584 21.8316 0.0677312 21.9812 0.100248C22.1309 0.132765 22.2724 0.195061 22.3975 0.283426C22.5225 0.371792 22.6285 0.48442 22.7092 0.614604C22.7898 0.744788 22.8434 0.889865 22.8668 1.0412C22.8902 1.19253 22.8829 1.34702 22.8453 1.49547L18.3289 24.5933Z",
    fill: "#66757F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6516 1.62418C14.8764 0.153954 8.44534 3.28907 7.28711 8.62684C7.28711 8.62684 6.96445 10.1131 7.70845 10.2748C8.45156 10.4366 10.2613 9.27218 10.2613 9.27218L28.8462 13.306C28.8462 13.306 30.0098 15.1157 30.7538 15.2775C31.4978 15.4393 31.8196 13.9522 31.8196 13.9522C32.9787 8.61351 28.4258 3.0944 21.6516 1.62418Z",
    fill: "#DD2E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6516 1.62422C16.5191 0.510444 11.4196 3.93444 10.2613 9.27133C10.2613 9.27133 9.93867 10.7584 11.4258 11.0811C12.9129 11.4047 15.4658 10.4011 15.4658 10.4011L23.6427 12.1762C23.6427 12.1762 25.5502 14.1469 27.0373 14.4704C28.5244 14.7922 28.8462 13.3051 28.8462 13.3051C30.0044 7.96822 26.7831 2.738 21.6516 1.62422Z",
    fill: "#FFE8B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6516 1.62383C18.9822 1.04517 16.6231 5.06383 15.4649 10.4007C15.4649 10.4007 17.3724 12.3723 18.8587 12.6941L19.6027 12.8567C21.0898 13.1785 23.6418 12.1758 23.6418 12.1758C24.8009 6.83894 24.3209 2.20339 21.6516 1.62383Z",
    fill: "#DD2E44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0836 24.8423C14.5004 24.4628 15.6391 24.5525 16.3058 24.3072C16.9724 24.0619 17.3893 23.7499 17.9449 23.973C18.5004 24.1961 18.6667 24.5303 19.1947 24.5756C19.7227 24.621 20.1111 24.933 19.8889 25.1783C19.6667 25.4236 17.9164 25.5125 16.7502 25.5125C15.584 25.5125 13.5689 25.3116 14.0836 24.8423Z",
    fill: "#FFAC33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5099_13198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeach);
export default __webpack_public_path__ + "static/media/beach.8ff2af377216c701d88dba325efec67a.svg";
export { ForwardRef as ReactComponent };